"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PACKAGE_TEST = exports.GET_RELATED_PACKAGES = exports.GET_PACKAGE_STATIC_CONTENT = exports.GET_PACKAGE_DETAILS = exports.GET_PACKAGE_CLINICLIST = exports.GET_PACKAGE_AMOUNT_LIST = exports.GET_PACKAGES_LIST = exports.GET_FACILITY_PACKAGES = exports.GET_CMS_PACKAGE_LIST = exports.GET_BOOKED_PACKAGE_LIST = exports.GET_BOOKED_PACKAGE_DETAILS = exports.GET_ALL_ACTIVE_PACKAGES = exports.CANCEL_PACKAGE = exports.BOOK_PACKAGE = exports.BOOK_HEALTH_PACKAGE = void 0;
const GET_FACILITY_PACKAGES = exports.GET_FACILITY_PACKAGES = 'facilityPackages';
const GET_PACKAGES_LIST = exports.GET_PACKAGES_LIST = 'packageList';
const GET_PACKAGE_DETAILS = exports.GET_PACKAGE_DETAILS = 'packageDetails';
const GET_PACKAGE_CLINICLIST = exports.GET_PACKAGE_CLINICLIST = 'packageCliniclist';
const GET_BOOKED_PACKAGE_LIST = exports.GET_BOOKED_PACKAGE_LIST = 'bookedPackageList';
const GET_BOOKED_PACKAGE_DETAILS = exports.GET_BOOKED_PACKAGE_DETAILS = 'bookedPackageDetails';
const GET_PACKAGE_AMOUNT_LIST = exports.GET_PACKAGE_AMOUNT_LIST = 'packageAmountList';
const CANCEL_PACKAGE = exports.CANCEL_PACKAGE = 'cancelPackage';
const BOOK_PACKAGE = exports.BOOK_PACKAGE = 'bookPackage';
const GET_CMS_PACKAGE_LIST = exports.GET_CMS_PACKAGE_LIST = 'cmsPackageList';
const BOOK_HEALTH_PACKAGE = exports.BOOK_HEALTH_PACKAGE = 'bookPackage';
const PACKAGE_TEST = exports.PACKAGE_TEST = 'test';
const GET_PACKAGE_STATIC_CONTENT = exports.GET_PACKAGE_STATIC_CONTENT = 'getStaticContent';
const GET_RELATED_PACKAGES = exports.GET_RELATED_PACKAGES = 'getRelatedPackages';
const GET_ALL_ACTIVE_PACKAGES = exports.GET_ALL_ACTIVE_PACKAGES = 'getAllActivePackages';